import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { TmsApiService } from '../../../shared/services/tms-api/tms-api.service';

@Injectable({
  providedIn: 'root'
})
export class TicketAssignmentGuardService implements CanActivate {
  private _hasValidEntitlements = false;

  constructor(
    private _tmsApiService: TmsApiService,
    private router: Router
  ) {}

  canActivate(router: ActivatedRouteSnapshot, stage: RouterStateSnapshot): boolean {
    if (this._tmsApiService.getEntitlements().length > 0) {
      console.log('Access Granted');

      return true;
    } else {
      console.log('Access Denied');
      this.router.navigate(['/']);

      return false;
    }
  }

}
